<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="sapSalesOrderDetails"
        @reset="resetHandle"
        @select="selectHandle">
      <template slot="adSearch">
        <div class="vm-search">
          <el-form :inline="true" :model="filter" label-width="65px" @keyup.enter.native="loadData(1)">
            <el-form-item label="订单编号">
              <el-input v-model.trim="filter.salesOrderNo" placeholder="请输入订单编号" clearable/>
            </el-form-item>
            <el-form-item label="订单类型">
              <el-select
                  v-model="filter.salesOrderCategory"
                  placeholder="请选择订单类型">
                <el-option v-for="item in property" :key="item.no" :value="item.no" :label="item.name"/>
              </el-select>
            </el-form-item>
            <el-form-item label="客户名称">
              <el-input v-model.trim="filter.customerName" placeholder="请输入客户名称" clearable/>
            </el-form-item>
            <el-form-item label="厂家型号">
              <el-input v-model.trim="filter.manufacturerModel" placeholder="请输入规格型号" clearable/>
            </el-form-item>
            <el-form-item label="计划交期">
              <el-date-picker
                  v-model="deliveryDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('deliveryDateRange', 'deliveryBeginDate', 'deliveryEndDate')"/>
            </el-form-item>
            <!--            <el-form-item label="制单日期">-->
            <!--              <el-date-picker-->
            <!--                  v-model="createDateRange"-->
            <!--                  type="daterange"-->
            <!--                  range-separator="至"-->
            <!--                  start-placeholder="开始时间"-->
            <!--                  end-placeholder="结束时间"-->
            <!--                  value-format="yyyy-MM-dd"-->
            <!--                  @change="dateRangeChange('createDateRange', 'orderBeginDate', 'orderEndDate')"/>-->
            <!--            </el-form-item>-->
            <el-form-item label="销售交期">
              <el-date-picker
                  v-model="salesDeliveryDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('salesDeliveryDateRange', 'salesDeliveryBeginDate', 'salesDeliveryEndDate')"/>
            </el-form-item>
            <el-form-item label="创建日期">
              <el-date-picker
                  v-model="createDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('createDateRange', 'createBeginDate', 'createEndDate')"/>
            </el-form-item>
            <!--            <el-form-item label="制单人">-->
            <!--              <el-input v-model.trim="filter.creator" placeholder="请输入" clearable/>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="ERP编号">-->
            <!--              <el-input v-model.trim="filter.billNo" placeholder="请输入ERP订单编号" clearable/>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="合同号">-->
            <!--              <el-input v-model.trim="filter.customerContractNo" placeholder="请输入合同号" clearable/>-->
            <!--            </el-form-item>-->
            <!--            <el-form-item label="项目名称">-->
            <!--              <el-input v-model.trim="filter.projectName" placeholder="请输入项目名称" clearable/>-->
            <!--            </el-form-item>-->
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
            </el-form-item>
            <el-form-item label="物料名称">
              <el-input v-model.trim="filter.materialName" placeholder="请输入物料名称" clearable/>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input v-model.trim="filter.specification" placeholder="请输入规格型号" clearable/>
            </el-form-item>
            <el-form-item label="制单人">
              <el-input v-model.trim="filter.creatorName" placeholder="请输入制单人" clearable/>
            </el-form-item>
            <el-form-item label="销售员">
              <el-input v-model.trim="filter.salePersonName" placeholder="请输入销售员" clearable/>
            </el-form-item>
            <el-form-item label="商务专员">
              <el-input v-model.trim="filter.businessSpecialistName" placeholder="请输入商务专员" clearable/>
            </el-form-item>
            <el-form-item label="发货状态">
              <el-select v-model="filter.deliverStatus" clearable placeholder="请选择状态">
                <el-option label="已发" :value="1"/>
                <el-option label="未发" :value="2"/>
              </el-select>
            </el-form-item>
            <!--            <el-form-item label="备注">-->
            <!--              <el-input v-model.trim="filter.detailNote" placeholder="请输入备注" clearable/>-->
            <!--            </el-form-item>-->
          </el-form>
        </div>
      </template>
      <template slot="actionBtn"/>
      <template slot="otherBtn">
        <el-button v-if="limits.borrowAuth" type="primary" :disabled="selection.length===0" @click="getClientContractByDetail">
          借出转销售合同
        </el-button>
        <el-button v-if="limits.batchJishouAuth" type="primary" :disabled="selection.length===0" @click="getZJE">
          批量寄售冲账
        </el-button>
      </template>
    </view-table>
    <client-contract-edit ref="clientContractEdit"/>
    <sales-order-ji-shou-edit ref="salesOrderJiShouEdit"/>
  </div>
</template>

<script>
  import loginUtil from "@/util/loginUtil";
  import ViewTable from "@/components/ViewTable";
  import ClientContractEdit from "@/views/SalesManage/SalesClientContract/ClienContractEdit";
  import SalesOrderJiShouEdit from "@/views/SalesManage/SalesOrder/SalesOrderJiShouEdit";

  export default {
    name: "SalesOrderDetailList",
    components: {ClientContractEdit, ViewTable, SalesOrderJiShouEdit},
    data() {
      return {
        limits: {
          borrowAuth: this.$auth(322),
          batchJishouAuth: this.$auth(331),
        },
        property: [],
        filter: {
          salesOrderNo: "",
          deliveryBeginDate: "",
          deliveryEndDate: "",
          orderBeginDate: "",
          orderEndDate: "",
          createBeginDate: "",
          createEndDate: "",
          submitBeginDate: "",
          submitEndDate: "",
          salesDeliveryBeginDate: "",
          salesDeliveryEndDate: "",
          customerName: "",
          creator: "",
          salesOrderCategory: [],
          customerContractNo: "",
          projectName: "",
          billNo: "",
          status: "",
          deliverStatus: "",
          materialNo: "",
          materialName: "",
          specification: "",
          detailNote: "",
        },
        columnsProperty: [
          {
            key: "salesOrderNo",
            width: 130,
            align: "center",
          },
          {
            key: "salesOrderCategoryName",
            width: 160,
            align: "center",
          },
          {
            key: "rowIndex",
            width: 150,
            align: "center",
          },
          {
            key: "rowIndex",
            width: 100,
          },
          {
            key: "materialNo",
            width: 200,
          },
          {
            key: "materialName",
            width: 260,
          },
          {
            key: "price",
            width: 100,
          },
          {
            key: "quantity",
            width: 100,
          },
          {
            key: "unit",
            width: 100,
          },
          {
            key: "deliveryDate",
            width: 160,
          },
          {
            key: "salesDeliveryDate",
            width: 160,
          },
          {
            key: "specification",
            width: 260,
          },
          {
            key: "manufacturerModel",
            width: 260,
          },
          {
            key: "customerNo",
            width: 100,
          },
          {
            key: "customerName",
            width: 260,
          },
          {
            key: "salesOrderCategoryName",
            width: 260,
          },
          {
            key: "remainQuantity",
            width: 100,
          },
          {
            key: "invoiceQty",
            width: 100,
          },
          {
            key: "totalNetPrice",
            width: 100,
          },
          {
            key: "totalTaxPrice",
            width: 100,
          },
        ],
        options: [],
        submitDateRange: [],
        salesDeliveryDateRange: [],
        createDateRange: [],
        deliveryDateRange: [],
        importCustomerId: "1963",
        YWTimportLoading: false,
        importLoading: false,
        importCustomerLoading: false,
        uploadUrl: window.config.basicServerUrl + "sd/so/importContractFile",
        uploadHeaders: {Authorization: loginUtil.getToken()},
        disabled: false,
        importPdfLoading: false,
        uploadLoading: false,
        selection: [],
        submitLoading: false,
      };
    },

    watch: {
      "filter.deliveryBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.deliveryDateRange = [];
            this.deliveryDateRange.push(this.filter.deliveryBeginDate);
            this.deliveryDateRange.push(this.filter.deliveryEndDate);
          }
        },
      },
      "filter.orderBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.orderBeginDate);
            this.createDateRange.push(this.filter.orderEndDate);
          }
        },
      },
      "filter.submitBeginDate": {
        handler(newVal) {
          if (newVal) {
            this.submitDateRange = [];
            this.submitDateRange.push(this.filter.submitBeginDate);
            this.submitDateRange.push(this.filter.submitEndDate);
          }
        },
      },
    },

    // created() {
    //   this.getAreaOptions();
    // },
    mounted() {
      this.getSalesOrderCategory();
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      getSalesOrderCategory() {
        this.$http.get("basic", "sapSalesOrders/getSalesOrderCategory").then((res) => {
          if (res.success) {
            this.property = res.data;
          }
        });
      },

      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },


      selectHandle(selection) {
        this.selection = selection;
      },

      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },

      //未提交、退单可以编辑删除
      otherAuth() {
        return true;
      },

      getClientContractByDetail() {
        if (this.selection.length === 0) {
          this.$message.error("请先选择数据");
        } else if (this.selection.filter(item => item.property !== "ZKB").length) {
          this.$message.error("仅能勾选借出订单!");
        } else if (this.selection.filter(item => item.remainQuantity <= 0).length) {
          this.$message.error("存在剩余数量不为0的行项!");
        } else {
          let ids = [];
          this.selection.forEach(item => ids.push(item.pkId));
          this.$http.post("basic", "sapSalesOrderDetails/getClientContractByDetail", ids)
            .then((resp) => {
              if (resp.success) {
                console.log(resp);
                this.$refs.clientContractEdit.open(null, false, resp.data);
              }
            });
        }

      },

      getZJE() {
        if (this.selection.length === 0) {
          this.$message.error("请先选择数据");
        } else if (this.selection.filter(item => item.property !== "ZJB").length) {
          this.$message.error("仅能勾选寄售发出订单!");
        } else if (this.selection.filter(item => item.remainQuantity <= 0).length) {
          this.$message.error("存在剩余数量不为0的行项!");
        } else {
          this.$refs.salesOrderJiShouEdit.open(this.selection);
        }

      },
    },
  };
</script>

